module.exports = __webpack_public_path__ + "img/DSC_1126.cd907166.jpg";